@if (view$ | async; as view) {
    <div class="modal-header">
        <h4 class="modal-title">
            {{ 'common_SELECT_METERS' | translate }}
        </h4>
    </div>

    <div class="modal-body">
        @if (view.settingsPending) {
            <app-select-meters-settings
                [formGroup]="view.meterSettingsFormGroup"
                [settings]="view.settings" />
            @if (view.singleMeterWarning) {
                <div class="alert alert-warning mt-3" role="alert">
                    {{ 'consumption-agents_single_meter_warning' | translate }}
                </div>
            }
        } @else {
            <div class="row">
                <div class="col-4">
                    <b>{{ 'consumption-agents_Selected-meter-type' | translate }}</b>
                    <br />
                    {{
                        'mappers_meterType.' + view.meterSettingsFormGroup.value.meterSuperTypeNo
                            | translate: 'online' : 'common'
                    }}
                </div>

                <div class="col-4">
                    <b>{{ 'consumption-agents_selected-meter-usages-and-units' | translate }}</b>
                    <br />
                    @for (
                        meterType of view.formGroup.controls.meterSettingsFormGroup.value
                            .selectableUsageAndUnits;
                        track $index
                    ) {
                        @if (meterType.selected) {
                            {{ meterType.name }}
                            <br />
                        }
                    }
                </div>

                <div class="col-4">
                    <b>
                        {{ 'reporting_GROUP_NAME' | translate }}
                        {{ view.meterSettingsFormGroup.value.groupName ? '  1' : '' }}
                    </b>
                    <br />
                    {{ view.meterSettingsFormGroup.value.groupName }}

                    @if (view.meterSettingsFormGroup.value.groupName2) {
                        <br />
                        <b>{{ 'reporting_GROUP_NAME' | translate }} 2</b>
                        <br />
                        {{ view.meterSettingsFormGroup.value.groupName2 }}
                    }
                </div>
            </div>

            <app-select-meters-table
                class="mb-3"
                [formGroup]="view.meterIdGroupsFormGroup"
                [meters]="view.selectableMeters" />
        }
    </div>

    <div class="modal-footer">
        <button class="btn btn-outline-primary" type="button" (click)="dismiss()">
            {{ 'reporting_CLOSE' | translate }}
        </button>

        <button class="btn btn-outline-primary" type="button" (click)="reset(view.formGroup)">
            {{ 'utilities_reset' | translate }}
        </button>

        @if (view.settingsPending) {
            <button
                class="btn btn-primary"
                type="button"
                [disabled]="view.singleMeterWarning"
                (click)="showMeters(view.selectableMeters, view.meterSettingsFormGroup)">
                {{ 'utilities_show_meters' | translate }}
            </button>
        } @else {
            <button class="btn btn-primary" type="button" (click)="submit(view.formGroup)">
                {{ 'actions_submit' | translate: 'online' : 'common' }}
            </button>
        }
    </div>
}
